<template>
  <div>
    <h1>Welcome Admin {{user.username}}</h1>
    <p>{{test()}}</p>
    <router-link to="/Attendance" tag="span">
      <v-btn>Attendance</v-btn>
    </router-link>
    <router-link to="/GamesPage" tag="span">
      <v-btn>Games</v-btn>
    </router-link>
      <v-btn v-on:click="$router.push({ name: 'UserAdder'})">Add User</v-btn>
  </div>
</template>

<script>
import db from "../database";
export default {
  name: "AdminDash",
  props: ["uid"],
  data() {
    return {
      user: ""
    };
  },


  mounted() {
    this.user = this.$store.getters.user;
  },
  methods: {
    test() {
      console.log(this.$store.getters.user);
    }
  }
};
</script>
